import { Typography, IconButton, Box, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { titleHeader } from '../../../utils/greetingsFormaters';
import { documentationRoutes } from '../../../views/documentation/documentationRoutes';

const NameHeader = ({ route }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const title = titleHeader(location);

    const docFile = documentationRoutes[location.pathname];

    const handleOpenDocs = () => {
        if (!docFile) return;

        navigate('/documentacao', {
            state: { file: docFile }
        });
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexGrow: 1,
                minWidth: 0,
                mt: 2
            }}
        >
            <Typography variant="h2" noWrap sx={{ display: { xs: 'none', sm: 'block' } }}>
                {title}
            </Typography>

            {docFile && (
                <Tooltip title={t('docs')}>
                    <IconButton onClick={handleOpenDocs} sx={{ ml: 1 }} color="primary">
                        <HelpOutlineIcon />
                    </IconButton>
                </Tooltip>
            )}
        </Box>
    );
};

export default NameHeader;
